<template>

    <v-layout row justify-center>
        <v-dialog v-model="showPopUpAddHome" persistent>
            <v-card>
                <v-card-title class="headline">
                    {{ $vuetify.t("$vuetify.AddToHome.installApp")}}
                </v-card-title>
                <v-card-text> {{
                    $vuetify.t("$vuetify.AddToHome.installAppMessage") }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="enableUndo" color="#808080" flat
                           @click="showPopUpAddHome = false">{{
                        $vuetify.t("$vuetify.AddToHome.discardAdd")}}
                    </v-btn>
                    <v-btn class="accent" color="primary" flat
                           @click="addToHome()">{{
                        $vuetify.t("$vuetify.AddToHome.add")}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showMessageAddToHome" persistent>
            <v-card>
                <v-card-title class="headline">
                    {{ $vuetify.t("$vuetify.AddToHome.installApp")}}
                </v-card-title>
                <v-card-text>
                    {{$vuetify.t("$vuetify.AddToHome.howToInstall")}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="enableUndo" color="#808080" flat
                           @click="showMessageAddToHome = false">{{
                        $vuetify.t("$vuetify.AddToHome.discardAdd")}}
                    </v-btn>
                    <v-btn class="accent" color="primary" flat
                           @click="showMessageAddToHome= false">{{
                        $vuetify.t("$vuetify.AddToHome.ok")}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>


</template>

<script>

    export default {
        data() {
            return {
                deferredEvent: null,
                showPopUpAddHome: false,
                showMessageAddToHome: false

            }
        },
        props: {
            enableUndo: {
                type: Boolean,
                default: false
            }

        },
        methods: {
            captureBeforeInstallPrompt(event) {
                event.preventDefault()
                this.deferredEvent = event
                this.showPopUpAddHome = true

            },
            addToHome() {
                if (this.deferredEvent) {
                    this.deferredEvent.prompt()
                    this.showPopUpAddHome = false
                } else {
                    console.error("Missing event beforeinstallprompt")
                }
            },
            $_addListenerBeforeInstPrompt() {
                window.addEventListener('beforeinstallprompt', this.captureBeforeInstallPrompt);

            },
            $_checkBeforeInstPromptAvailable() {
                //nascondo il popup add to home se epr qualche motivo viene aperto
                this.showPopUpAddHome = false
                this.showMessageAddToHome = (window.onbeforeinstallprompt === undefined &&
                    !(window.matchMedia('(display-mode: standalone)').matches || navigator.standalone == true))

            }
        },
        created() {
            this.$_addListenerBeforeInstPrompt()
            this.$_checkBeforeInstPromptAvailable()
        }
    }

</script>

<style scoped lang="scss">

</style>